import { ProductUnit } from './aggregate-cart';

export type PromotionFamily = 'buyXPayY' | 'progressive' | 'nthUnit';

export interface UnitDiscount {
  unit: ProductUnit;
  amount: number;
  sourcePromotionId: string;
}

export interface PerPromoBreakdown {
  promotionId: string;
  discountAmount: number;
  unitDiscounts: UnitDiscount[];
}

export interface FamilyOutcome {
  family: PromotionFamily;
  totalDiscount: number;
  perPromoBreakdown: PerPromoBreakdown[];
}

/**
 * Builds a `FamilyOutcome` from a Map keyed by `sourcePromotionId`. Sums each
 * source's amounts into a `PerPromoBreakdown` entry and totals the family.
 * Used by calculators that have multiple-source attribution (buyXPayY, nthUnit
 * winners that share the same source budget).
 */
export function buildFamilyOutcome(
  family: PromotionFamily,
  unitDiscountsBySource: Map<string, UnitDiscount[]>,
): FamilyOutcome {
  const perPromoBreakdown: PerPromoBreakdown[] = [];
  for (const [promotionId, unitDiscounts] of unitDiscountsBySource) {
    const discountAmount = unitDiscounts.reduce((sum, ud) => sum + ud.amount, 0);
    perPromoBreakdown.push({ promotionId, discountAmount, unitDiscounts });
  }
  const totalDiscount = perPromoBreakdown.reduce((sum, b) => sum + b.discountAmount, 0);
  return { family, totalDiscount, perPromoBreakdown };
}
